export default __webpack_public_path__ + "static/media/customer-journey-template.935de0c7.pptx";